

import {Component, Prop, Vue} from "vue-property-decorator";
import {BaseComponent} from "@/core/components/BaseComponent";
import {OnConversationCreatedEvent, OnConversationUpdatedEvent} from "@/core/services/conversation/conversation-socket";
import Avatar from "@/core/components.business/Avatar.vue";
import {DateHelper} from "@/helpers/date-helper";
import {ConversationManagementService} from "@/views/conversations/services/conversation-management-service";

@Component({
    components: {
        'user-icon': Avatar
    }
})
export default class NewConversationPopup extends BaseComponent {

    // Component properties:
    @Prop({required: true, type: Object}) event!: OnConversationCreatedEvent;

    private onPopupClick() {
        ConversationManagementService.openConversation(this.event.Conversation.Id);
        this.$bvToast.hide(`conversation-popup-${this.event.Conversation.Id}`);
    }

    public static $liveCreate(parent: Vue, event: OnConversationCreatedEvent) {
        return parent.$createElement(NewConversationPopup, {
            props: {
                event: event
            }
        })
    }
}
